import { render, staticRenderFns } from "./xin.vue?vue&type=template&id=77c97c56&scoped=true&"
import script from "./xin.vue?vue&type=script&lang=js&"
export * from "./xin.vue?vue&type=script&lang=js&"
import style0 from "./xin.vue?vue&type=style&index=0&id=77c97c56&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c97c56",
  null
  
)

export default component.exports